<template>
  <div class="pifs-container" v-if="pifs.length > 0">
    <h4 class="heading">{{ $t("pifs") }}</h4>
    <div class="pifs-row">
      <div v-for="p in pifs" :key="p.ISIN" class="pif">
        <div style="display: flex">
          <img src="@/assets/images/chart.png" />
          <p style="color: #2f3a57;margin-left: 15px">{{ p.FUND_NAME }}</p>
        </div>
        <p class="pif-quantity">{{ getFormatedQuantity(p.QUANTITY) }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import accounting from "accounting";

export default {
  data() {
    return {
      pif: null
    };
  },
  computed: {
    ...mapGetters(["pifs", "isUserVIP"])
  },
  methods: {
    getFormatedQuantity(quantity) {
      return accounting.formatNumber(quantity, 0, " ");
    }
  },
  mounted() {
    if (this.$store.getters.isUserVIP === false) {
      this.$store.dispatch("fetchPifs");
    }
  }
};
</script>
<style scoped>
.heading {
  font-size: 36px;
  font-weight: normal;
  color: #222c44;
}
.pifs-row {
  display: flex;
  width: 100%;
}
.pif {
  border: 1px solid #2f3a57;
  border-radius: 3px;
  margin-right: 15px;
  margin-top: 15px;
  padding: 15px 15px 35px 15px;
  position: relative;
  display: inline-block;
}
.pif > div > p {
  font-size: 14px;
  color: #222c44 !important;
}
.pif p {
  font-size: 15px;
}
.pif img {
  width: 35px;
  height: 35px;
}
.pif-quantity {
  position: absolute;
  bottom: 15px;
  right: 15px;
}
@media (max-width: 1100px) {
  .pif {
    width: 200px;
  }
}
</style>
